import { render } from "./EmployeePage.vue?vue&type=template&id=8521bb30&scoped=true"
import script from "./EmployeePage.vue?vue&type=script&lang=js"
export * from "./EmployeePage.vue?vue&type=script&lang=js"

import "./EmployeePage.vue?vue&type=style&index=0&id=8521bb30&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8521bb30"]])

export default __exports__